import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { createLoadingSelector } from '../../../../apis/selectors';
import { launchProperksChallenge } from '../../../../actions/metricsAction';
import { defaultProperksChallenge } from '../../../../reducers/metricsReducer';

const actions = ['LAUNCH_PROPERKS_CHALLENGE'];
const loadingSelector = createLoadingSelector(actions);

export const useChallengeForm = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => loadingSelector(state));
  const properksInitialValue = useSelector(state => state.metrics.properksInitialValue)
  const properksUpdateAt = useSelector(state => state.metrics.properksUpdateAt)

  const [formData, setFormData] = useState(defaultProperksChallenge);

  const handleChange = (target, value) => {
    setFormData({
      ...formData,
      [target]: value,
    });
  };

  const handleSubmit = () => {
    const data = {
      name: formData.name,
      professions: formData.professionType,
      levels: formData.levels,
      states: formData.states,
      type: formData.type,
      completed_count: Number(formData.count || 0),
      reward: Number(formData.reward || 0),
      date_start: moment(formData.dateRange.from).format('YYYY-MM-DD'),
      date_end: moment(formData.dateRange.to).format('YYYY-MM-DD'),
    }
    dispatch(launchProperksChallenge(data));
  };

  // for relaunch form
  useEffect(() => {
    setFormData(properksInitialValue);
  }, [properksInitialValue, properksUpdateAt])

  const isDisabled =
    !formData?.count ||
    !formData?.type ||
    !formData?.dateRange?.from || 
    !formData?.dateRange?.to || 
    !formData?.professionType?.length || 
    !formData?.levels?.length || 
    !formData?.reward ||
    !formData?.states?.length;

  return {
    isLoading,
    isDisabled,

    formData,
    handleChange,
    handleSubmit,
  };
};
